export const GET_BUILDER_QUESTIONNAIRES = "GET_BUILDER_QUESTIONNAIRES";
export const GET_BUILDER_QUESTIONS = "GET_BUILDER_QUESTIONS";
export const TOGGLE_BUILDER_NODE = "TOGGLE_BUILDER_NODE";
export const GET_BUILDER_QUESTION_CONTENT = "GET_BUILDER_QUESTION_CONTENT";
export const UPDATE_BUILDER_TRANSLATION_IMAGE = "UPDATE_BUILDER_TRANSLATION_IMAGE";
export const CLEAR_BUILDER_QUESTIONNAIRE_CONTENT = "CLEAR_BUILDER_QUESTIONNAIRE_CONTENT";
export const CLEAR_BUILDER_TREE_NODES = "CLEAR_BUILDER_TREE_NODES";
